import React, { useState, useMemo, useCallback } from 'react';
import { Box, useDisclosure, Portal } from '@chakra-ui/react';
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import Footer from 'components/footer/FooterAdmin.js';
import { SidebarContext } from 'contexts/SidebarContext';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import routes from 'routes';

export default function Dashboard(props) {
    const { ...rest } = props;
    const [toggleSidebar, setToggleSidebar] = useState(false);
    const { onOpen } = useDisclosure();
    const location = useLocation();

    const getActiveRoute = useCallback((routes) => {
        const path = location.pathname;
        for (let route of routes) {
            if (route.path === path) return route.name;
            if (route.collapse || route.category) {
                const result = getActiveRoute(route.items);
                if (result) return result;
            }
        }
        return 'Default Brand Text';
    }, [location.pathname]);

    const getActiveNavbar = useCallback((routes) => {
        const path = location.pathname;
        for (let route of routes) {
            if (route.path === path) return route.secondary;
            if (route.collapse || route.category) {
                const result = getActiveNavbar(route.items);
                if (result !== false) return result;
            }
        }
        return false;
    }, [location.pathname]);

    const getActiveNavbarText = useCallback((routes) => {
        const path = location.pathname;
        for (let route of routes) {
            if (route.path === path) return route.messageNavbar;
            if (route.collapse || route.category) {
                const result = getActiveNavbarText(route.items);
                if (result) return result;
            }
        }
        return false;
    }, [location.pathname]);

    const memoizedRoutes = useMemo(() => 
        routes
            .filter(route => route.path !== '/login')
            .map((prop, key) => (
                <Route path={prop.path} element={<prop.component />} key={key} />
            )), []);

    const activeBrandText = useMemo(() => getActiveRoute(routes), [getActiveRoute]);
    const activeNavbar = useMemo(() => getActiveNavbar(routes), [getActiveNavbar]);
    const activeNavbarText = useMemo(() => getActiveNavbarText(routes), [getActiveNavbarText]);

    return (
        <Box>
            <SidebarContext.Provider value={{ toggleSidebar, setToggleSidebar }}>
                <Sidebar routes={routes} display='none' {...rest} />
                <Box
                    float='right'
                    minHeight='100vh'
                    height='100%'
                    overflow='auto'
                    position='relative'
                    maxHeight='100%'
                    w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
                    maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
                    transition='all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'
                    transitionDuration='.2s, .2s, .35s'
                    transitionProperty='top, bottom, width'
                    transitionTimingFunction='linear, linear, ease'>
                    <Portal>
                        <Box>
                            <Navbar
                                onOpen={onOpen}
                                logoText={'Your Dashboard'}
                                brandText={activeBrandText}
                                secondary={activeNavbar}
                                message={activeNavbarText}
                                {...rest}
                            />
                        </Box>
                    </Portal>
                    <Box mx='auto' p={{ base: '20px', md: '30px' }} pe='20px' minH='100vh' pt='50px'>
                        <Routes>
                            {memoizedRoutes}
                            <Route path="*" element={<Navigate to="/" />} /> 
                        </Routes>
                    </Box>
                    <Box>
                        <Footer />
                    </Box>
                </Box>
            </SidebarContext.Provider>
        </Box>
    );
}